// @ts-strict-ignore
import React from 'react'

interface RangeProps {
  min?: number
  max?: number
  step?: number
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
}

export const Range = React.forwardRef<HTMLInputElement, RangeProps>(
  ({ min, max, step, onChange }: RangeProps, ref) => {
    return (
      <input
        ref={ref}
        type='range'
        className='Range'
        min={min}
        max={max}
        step={step}
        onChange={onChange}
      />
    )
  },
)

export default Range
